import type { ApiRoute, NoBody, NoPathParams } from "../../api"
import type { GetInteriorOptionsQueryParams } from "../../common/colors/interiorColor/GetInteriorOptionsQueryParams"
import type { InteriorOptionView } from "../../common/colors/interiorColor/InteriorOptionView"

export const getInteriorOptionsRoute: ApiRoute<
	NoPathParams,
	GetInteriorOptionsQueryParams,
	NoBody,
	InteriorOptionView[]
> = {
	buildUrl: () => "/colors/interior/options",
	method: "get",
	path: "/colors/interior/options",
}
